import { Typography, Table, TableHead, TableBody, TableRow, TableCell, Link } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledTableHead = styled(TableHead)({
  background: '#F4F4F6',
});

const StyledTable = styled(Table)({
  '& td': {
    padding: '0.9em',
  },
});

export function SupportedList() {
  return (
    <>
      <StyledTable>
        <StyledTableHead>
          <TableRow>
            <TableCell>
              <Typography variant="body1">
                <strong>Supported browsers</strong>
              </Typography>
            </TableCell>
          </TableRow>
        </StyledTableHead>
        <TableBody>
          <TableRow>
            <TableCell>
              <Typography variant="body1">
                <Link
                  color="inherit"
                  underline="always"
                  target="_blank"
                  rel="noopener"
                  href="https://www.google.com/chrome/"
                >
                  Chrome
                </Link>
              </Typography>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <Typography variant="body1">
                <Link
                  color="inherit"
                  underline="always"
                  target="_blank"
                  rel="noopener"
                  href="https://www.mozilla.org/en-US/firefox/new/"
                >
                  Firefox
                </Link>
              </Typography>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <Typography variant="body1">
                <Link
                  color="inherit"
                  underline="always"
                  target="_blank"
                  rel="noopener"
                  href="https://support.apple.com/downloads/safari"
                >
                  Safari
                </Link>
              </Typography>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell style={{ borderBottom: 'none' }}>
              <Typography variant="body1">
                <Link
                  color="inherit"
                  underline="always"
                  target="_blank"
                  rel="noopener"
                  href="https://www.microsoft.com/en-us/edge"
                >
                  Edge
                </Link>
              </Typography>
            </TableCell>
          </TableRow>
        </TableBody>
      </StyledTable>
    </>
  );
}
